import type { Chain } from "wagmi";

export const W3_CACHE_TIME = 12_000; //ms
export const W3_STALE_TIME = 0;

export const ARBITRUM_MAINNET_ID =
  process.env.NEXT_PUBLIC_ARBITRUM_MAINNET_ID ?? 2;
export const ARBITRUM_TESTNET_ID =
  process.env.NEXT_PUBLIC_ARBITRUM_TESTNET_ID ?? 4;
export const GANACHE_TESTNET_ID =
  process.env.NEXT_PUBLIC_GANACHE_TESTNET_ID ?? 3;

export const MAX_LEVERAGE = 20;
export const MIN_MARGIN = 1 / MAX_LEVERAGE;
export const MIN_LEVERAGE = 2;
export const PARAMS_DECIMALS = 6;

export const SWIPEABLE_CONFIG = {
  delta: 10, // min distance(px) before a swipe starts. *See Notes*
  preventDefaultTouchmoveEvent: false, // call e.preventDefault *See Details*
  trackTouch: true, // track touch input
  trackMouse: true, // track mouse input
  rotationAngle: 0, // set a rotation angle
};

export const SUGGESTIONS_PERCENTAGE = [1];
export const SUGGESTION_DECIMALS = 4;
export const INC_AMOUNT_STEP = "0.1";

export const HOUR_IN_S = 60 * 60;
export const DAY_IN_S = 24 * HOUR_IN_S;

export const CHART_BACK_GREEN = "#40BF00";
export const CHART_BACK_RED = "#E64595";
export const TEXT_GREEN = CHART_BACK_GREEN;
export const TEXT_RED = CHART_BACK_RED;

export const DATE_FORMAT = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "numeric",
  minute: "numeric",

  hour12: true,
});

export const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";

export const NOTIFICATION_VISIBLE_MS = 5_000;

export const MAINNET: Chain = {
  id: 1,
  name: "Ethereum",
  network: "homestead",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://cloudflare-eth.com"] },
    public: { http: ["https://cloudflare-eth.com"] },
  },
  testnet: false,
};

export const ARBITRUM_GOERLI: Chain = {
  id: 421613,
  name: "Arbitrum Goerli",
  network: "arb-goerli",
  nativeCurrency: {
    name: "agor",
    symbol: "AGOR",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://scn.equilab.io/arb/goerli-nitro/rpc"] },
    public: { http: ["https://scn.equilab.io/arb/goerli-nitro/rpcc"] },
  },
  testnet: true,
};

export const POLYGON_MUMBAI: Chain = {
  id: 80001,
  name: "Polygon Mumbai",
  network: "polygon-mumbai",
  nativeCurrency: {
    name: "matic",
    symbol: "MATIC",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://polygon-mumbai.blockpi.network/v1/rpc/public"] },
    public: { http: ["https://polygon-mumbai.blockpi.network/v1/rpc/public"] },
  },
  testnet: true,
};

export const ZKSYNC_GOERLI: Chain = {
  id: 280,
  name: "zkSync goerli",
  network: "zksync-goerli",
  nativeCurrency: {
    name: "weth",
    symbol: "WETH",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://testnet.era.zksync.dev"] },
    public: { http: ["https://testnet.era.zksync.dev"] },
  },
  testnet: true,
};

const CHAINS = [ARBITRUM_GOERLI, POLYGON_MUMBAI, ZKSYNC_GOERLI];

export const ARBITRUM_CHAIN_ID = 42161;

export const HIDDEN_FRONTEND_CHAINS = [ARBITRUM_CHAIN_ID];

export const PAPER_PLANE_LINK =
  "https://galxe.com/marginly/campaign/GCCWMU7Aj1";

export const SIGN_PREFIX =
  "I agree to participate in Marginly blast testnet contest ";

export const CONTEST_INIT_BALANCE = 10_000;

export const META_TITLE =
  "Marginly | Go up to 20X long or short on Blast AMM DEXs.";

export const META_DESCRIPTION =
  "A novel leverage protocol enabling margin trading of up to 20X leverage and empowering DEXs with new functionality, liquidity, and higher volumes.";

export const CAMELOT_LINK = "https://camelot.marginly.com/arbitrum";
